<template>
    <ListItemButton icon-name="baseline-share-24px" dusk="socialShareButton" @click="shareIssue">
        <span>
            {{ localizations[lang].tooltips.share }}
        </span>
    </ListItemButton>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import ListItemButton from '../Components/list/ListItemButton.vue';
import { uiAPI } from '../../../src/js/communication';

export default {
    components: { ListItemButton },
    props: {
        iconSize: {
            type: String,
            default: '18px',
        },
    },
    computed: {
        ...mapState(['issue', 'title', 'localizations', 'lang']),
        ...mapGetters(['canUseNativeShare']),
    },
    methods: {
        ...mapMutations(['openSocialShare']),
        shareIssue() {
            this.canUseNativeShare ? this.shareUsingShareApi() : this.openSocialShare();
        },
        shareUsingShareApi() {
            const issueDescription = this.issue.descriptionRawText || '';

            const text = issueDescription.length > 90 ? `${issueDescription.substring(0, 90)}...` : issueDescription;

            uiAPI.shareContent({
                title: `${this.localizations[this.lang].imReading} ${this.title}`,
                text,
                url: this.issue.issue_url,
            });
        },
    },
};
</script>

<style scoped lang="scss"></style>
